import {Action, createReducer, on} from '@ngrx/store';
import {RegionInfo} from '../models/region.model';
import {Constants} from '../shared/constants';
import {ServiceRegion} from '../../../common/constants';
import { UpdateRegionInfo} from '../actions/region.action';
const regionDetails = Constants.RegionDetails.RegionDetails;
export const initialState: RegionInfo = regionDetails[ServiceRegion.USA];
const reducer = createReducer(
  initialState,
  on(UpdateRegionInfo, (state, {regionInfo}) => ({
    ...state,
    ...regionInfo
  }))
);
export function RegionReducer(state: RegionInfo, action: Action) {
  return reducer(state, action);
}
